import { useEffect } from 'react';

interface DocumentMetaOptions {
  title?: string;
  description?: string;
  ogImage?: string;
}

const DEFAULT_TITLE = '安飞供应链';
const DEFAULT_DESCRIPTION = '安飞供应链系统';

function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * 轻量级的每页 SEO/分享信息设置：不引入 react-helmet-async，直接操作 document.head。
 * 页面卸载时把 <title> 和 description 还原成站点默认值，避免"离开这个页面后，
 * 别的页面还顶着这篇文章的标题"。Open Graph 标签不做还原（下一个设置过 og 的页面
 * 会覆盖，未设置过的页面本来也不依赖它）。
 */
export function useDocumentMeta({ title, description, ogImage }: DocumentMetaOptions) {
  useEffect(() => {
    const finalTitle = title ? `${title} - 安飞供应链` : DEFAULT_TITLE;
    document.title = finalTitle;
    setMetaTag('name', 'description', description || DEFAULT_DESCRIPTION);
    setMetaTag('property', 'og:title', title || DEFAULT_TITLE);
    setMetaTag('property', 'og:description', description || DEFAULT_DESCRIPTION);
    if (ogImage) setMetaTag('property', 'og:image', ogImage);

    return () => {
      document.title = DEFAULT_TITLE;
      setMetaTag('name', 'description', DEFAULT_DESCRIPTION);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, ogImage]);
}
